import { useEffect, useRef } from 'react';

/**
 * Esc clears a selection — the Vault's open item (card 01b22bf7): once an item
 * was opened, nothing led back to "nothing selected".
 *
 * Esc belongs to whatever has it first: a field being typed in (it may undo or
 * blur), an open dialog (it closes), or a handler that already took it
 * (`defaultPrevented`). Only an Esc nobody else wants deselects.
 *
 * @param {boolean} active     listen only while something is selected
 * @param {() => void} deselect
 */
export function useEscapeToDeselect(active, deselect) {
  const deselectRef = useRef(deselect);
  deselectRef.current = deselect;

  useEffect(() => {
    if (!active) return undefined;
    const onKeyDown = (e) => {
      if (e.key !== 'Escape' || e.defaultPrevented) return;
      const el = e.target;
      const editable = el instanceof HTMLElement
        && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName));
      if (editable || document.querySelector('[role="dialog"], [aria-modal="true"]')) return;
      deselectRef.current();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [active]);
}
